var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TutorialView',{attrs:{"cards":_vm.cards,"game":"rondo"}})}
var staticRenderFns = []

export { render, staticRenderFns }